import { useQuery } from '@tanstack/react-query'

import { useAuth } from '../auth/AuthProvider'
import { getOnboardingApiClient } from './onboarding-api'

// The organization (its clinics and the caller's role) changes only through
// organization actions, and each of them in the Dashboard refreshes this query.
// Reading it is a full server-side authorization, about 20 sequential database
// reads, so pages reuse a recent answer instead of asking again on every visit.
export const ORGANIZATION_STALE_MS = 5 * 60_000

export function useOrganizationAdmin() {
  const auth = useAuth()
  const user = auth.status === 'authenticated' ? auth.user : null

  return useQuery({
    queryKey: ['organization-admin', user?.uid ?? null],
    queryFn: () => getOnboardingApiClient().getOrganization!(user!),
    enabled: user !== null,
    retry: false,
    staleTime: ORGANIZATION_STALE_MS,
  })
}
